import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import router from "./router";
import store from "./store";
import {
  getToken
} from "@/utils/auth";
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

const whiteList = ["/login"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();
  let tokenInfo = getToken();
  console.log(tokenInfo)
  if (tokenInfo) {
    // await store.dispatch('app/initData');
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({
        path: "/"
      });
      NProgress.done();
    } else {
      next();
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
